import angular from 'angular';
import 'ng-file-upload';

const categoriesServices = angular.module('applicationModule.categoriesServices', []);

const checkFiles = (file) => {
    'use strict';

    const files = [];
    const names = [];
    if (angular.isDefined(file)) {
        files.push(file);
        names.push('file');
    }

    return {files, names};
};

categoriesServices.factory('Categories', ['CategoriesAPI', (CategoriesAPI) => {
    'use strict';

    return {
        getList: (appId, params) => {
            return CategoriesAPI.getList(appId, params)
                .then((response) => {
                    return response.data;
                });
        },
        getCategories: (appId, catId) => {
            return CategoriesAPI.getCategories(appId, catId);
        },
        get: (categoryId, appId) => {
            return CategoriesAPI.get(categoryId, appId);
        },
        post: (category) => {
            return CategoriesAPI.createCategory(category);
        },
        save: (category, editMode, file) => {
            if (editMode) {
                return CategoriesAPI.editCategory(category, file, editMode);
            } else {
                return CategoriesAPI.createCategory(category, file, editMode);
            }
        },
        remove: (categoryId) => {
            return CategoriesAPI.remove(categoryId);
        },
        search: (appId, search) => {
            return CategoriesAPI.search(appId, search);
        }
    };
}]);

categoriesServices.service('CategoriesAPI', ['$http', 'AppsoupAPI', 'Upload', function ($http, AppsoupAPI, Upload) {
    'use strict';

    const CATEGORIES_URL = AppsoupAPI.API_URL + '/app/categories/';

    this.getList = (appId, params) => {
        return $http.get(CATEGORIES_URL, {params: angular.extend(AppsoupAPI.getTableParams(params), {application_id: appId})});
    };

    this.getCategories = (appId, catId) => {
        if (catId) {
            return $http.get(CATEGORIES_URL + 'category-list/' + catId, {params: {application_id: appId}});
        }

        return $http.get(CATEGORIES_URL + 'category-list/', {params: {application_id: appId}});
    };

    this.get = (categoryId, appId) => {
        return $http.get(CATEGORIES_URL + categoryId, {params: {application_id: appId}});
    };

    this.createCategory = (category, file, editMode) => {
        const files = checkFiles(file);

        if (editMode) {
            if (angular.isDefined(file)) {
                const newFields = angular.extend(category, {_method: 'PUT'});

                return Upload.upload({
                    url: CATEGORIES_URL + category.id,
                    method: 'POST',
                    sendObjectsAsJsonBlob: false,
                    fields: newFields,
                    file: files.files,
                    fileFormDataName: files.names
                });
            } else {
                return $http.put(CATEGORIES_URL + category.id, category);
            }
        } else {
            if (angular.isDefined(file)) {
                return Upload.upload({
                    url: CATEGORIES_URL,
                    method: 'POST',
                    sendObjectsAsJsonBlob: false,
                    fields: category,
                    file: files.files,
                    fileFormDataName: files.names
                });
            } else {
                return $http.post(CATEGORIES_URL, category);
            }
        }
    };

    this.editCategory = (category) => {
        return $http.put(CATEGORIES_URL + category.id, category);
    };

    this.remove = (categoryId) => {
        return $http.delete(CATEGORIES_URL + categoryId);
    };

    this.search = (appId, search) => {
        return $http.get(CATEGORIES_URL + appId + '/tags', {params: {search: search}});
    };
}]);

export default categoriesServices;
